import React from 'react'
import { Table, useTable, Typography, List, TableColumnType, ModalProps, Button, Modal, Tag } from '@pankod/refine-antd'
import { ICleanupWindowQuestions } from 'interfaces'
import ReactMarkdown from 'react-markdown'
import { ReactMarkdownAllowedElements } from 'helpers'

type Props = {
  paperId: string
  modalProps: ModalProps
  close: any
}

const { Text } = Typography

const CleanupQuestionsList: React.FC<Props> = ({ paperId, modalProps, close }) => {
  const { tableQueryResult, tableProps } = useTable<ICleanupWindowQuestions>({
    resource: 'cleanup_window_questions',
    permanentFilter: [
      { field: 'paper_id', operator: 'eq', value: paperId },
      { field: 'in_cleanup', operator: 'eq', value: true },
    ],
    metaData: {
      fields: [
        'id',
        'created_at',
        'created_by',
        'question_id',
        'paper_id',
        { question: ['id', 'question_id', 'title', 'status', { subject: ['id', 'name'] }, { question_type: ['name'] }, { work_request: ['name'] }] },
      ],
    },
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const columnns: TableColumnType<ICleanupWindowQuestions>[] = [
    {
      key: 'question_id',
      title: 'Id',
      dataIndex: 'question.question_id',
      render(value, record, index) {
        return <Text>#{record?.question?.question_id}</Text>
      },
    },
    {
      title: 'Name',
      key: 'name',
      dataIndex: 'question.title',
      render(value, record, index) {
        return (
          <Text style={{ width: 150 }} ellipsis={{ tooltip: value }}>
            <ReactMarkdown
              allowedElements={ReactMarkdownAllowedElements}
              components={{
                p: ({ node, ...props }) => <p style={{ margin: '0' }} {...props} />,
                em: ({ node, ...props }) => <em style={{ margin: '0' }} {...props} />,
                strong: ({ node, ...props }) => <strong style={{ margin: '0' }} {...props} />,
                ol: ({ node, ...props }) => <ol style={{ margin: '0' }} {...props} />,
                ul: ({ node, ...props }) => <ul style={{ margin: '0' }} {...props} />,
                li: ({ node, ...props }) => <li style={{ margin: '0' }} {...props} />,
              }}
            >
              {record?.question?.title.length < 30
                ? record?.question?.title.substring(0, 30)
                : record?.question?.title.substring(0, 30).concat('...')}
            </ReactMarkdown>
          </Text>
        )
      },
    },
    {
      title: 'Question Type',
      key: 'question_type',
      render(value, record, index) {
        return <Text>{record?.question?.question_type?.name}</Text>
      },
    },
    {
      title: 'Subject',
      key: 'subject',
      render(value, record, index) {
        return <Text ellipsis={{ tooltip: record?.question?.subject?.name }}>{record?.question?.subject?.name}</Text>
      },
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'question.status',
      render(value, record, index) {
        return (
          <Tag
            color={
              value === 'Published'
                ? 'green'
                : value === 'Rejected at Review' || value === 'Rejected at Approval' || value === 'Retired'
                ? 'volcano'
                : value === 'Open (Require Amending)' || value === 'For Review (Require Amending)'
                ? 'pink'
                : 'geekblue'
            }
          >
            {record?.question?.status}
          </Tag>
        )
      },
    },
    {
      title: 'Work Request',
      key: 'work_request',
      render(value, record, index) {
        const workRequest = record?.question?.work_request?.name ?? 'Not from a work request'
        return <Text>{workRequest}</Text>
      },
    },
  ]
  return (
    <Modal
      {...modalProps}
      title="Questions Sent to Cleanup Window"
      style={{ minWidth: 900 }}
      footer={[<Button onClick={() => close()}>Close</Button>]}
    >
      <Table {...tableProps} loading={tableQueryResult?.isLoading} columns={columnns} size="small" />
    </Modal>
  )
}

export default CleanupQuestionsList
